<template>
  <nav>
    <router-link class="navigation-link" to="/">HOME</router-link>
    <router-link class="navigation-link" to="/top-selling-points"
      >TOP SELLING POINTS</router-link
    >
    <router-link class="navigation-link" to="/meetings-and-events"
      >MEETINGS & EVENTS</router-link
    >
    <router-link class="navigation-link" to="/local-area"
      >LOCAL AREA</router-link
    >
    <a class="navigation-link" href="#">PDF</a>
  </nav>
</template>

<script>
export default {
  name: "Navigation"
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
nav {
  width: 100%;
  height: $border-width;
  display: flex;
  justify-content: space-around;
  align-items: center;
  grid-area: 1 / 1 / 1 / 4;
  position: fixed;
  background: $black;
  z-index: 2;
}

.navigation-link {
  color: $gold;
  // font: bold 18px/48px $courier;
  font: bold 1rem $courier;
  text-decoration: none;
  padding: 0.5rem 2.5rem;
  // padding-left: 2.875rem;
  // padding-right: 2.875rem;
}

.navigation-link.router-link-exact-active {
  border: 2px solid $gold;
}

@media screen and (max-width: 1080px) {
  // .navigation
}

@media screen and (max-width: 812px) {
  nav {
    overflow-x: scroll;
    justify-content: space-between;
    display: flex;
    white-space: nowrap;
  }
}
</style>
